module.exports = __webpack_public_path__ + "static/media/house-damage.973e69bb.svg";